"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$tableColumnLine = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const _squareAttr_1 = __importDefault(require("./$squareAttr"));
const _sentencesArray_1 = __importDefault(require("./$sentencesArray"));
/**
 * The parser rule for {@link TableColumnLine} that represents a line of table column. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$tableColumnLine.spec.ts) for examples.
 */
exports.$tableColumnLine = factory_1.default
    .withName("tableColumnLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r.seqEqual("*"), "firstColumnIndicator")
    .and(() => lexical_1.$_, "midIndicatorsSpace")
    .and(r => r.nextIs(r => r.regExp(/^[-*]/)))
    .action(({ firstColumnIndicator, midIndicatorsSpace }) => ({ firstColumnIndicator, midIndicatorsSpace })))), "firstColumnIndicatorStruct")
    .and(r => r.regExp(/^[-*]/), "columnIndicator")
    .and(() => lexical_1.$_, "midSpace")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => _squareAttr_1.default, "entry")
    .and(() => lexical_1.$_, "trailingSpace")
    .action(({ entry, trailingSpace }) => {
    const attrEntry = entry.value;
    attrEntry.trailingSpace += trailingSpace;
    if (attrEntry.trailingSpaceRange)
        attrEntry.trailingSpaceRange[1] += trailingSpace.length;
    return {
        value: attrEntry,
        errors: entry.errors,
    };
}))), "attrEntries")
    .and(r => r
    .choice(c => c
    .orSequence(r => r
    .and(r => r.seqEqual("|"))
    .andOmit(r => r.nextIs(() => lexical_1.$_EOL)))
    .or(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(() => _sentencesArray_1.default))))), "columnsOrMultilineIndicator")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, firstColumnIndicatorStruct, columnIndicator, midSpace, attrEntries, columnsOrMultilineIndicator, lineEndText }) => {
    const [columns, multilineIndicator] = typeof columnsOrMultilineIndicator === "string"
        ? [null, columnsOrMultilineIndicator]
        : [columnsOrMultilineIndicator, null];
    const errors = [
        ...indentsStruct.errors,
        ...attrEntries.map(e => e.errors).flat(),
        ...(columns?.errors ?? []),
    ];
    return {
        value: new line_1.TableColumnLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            firstColumnIndicator: firstColumnIndicatorStruct?.firstColumnIndicator ?? "",
            midIndicatorsSpace: firstColumnIndicatorStruct?.midIndicatorsSpace ?? "",
            columnIndicator: columnIndicator,
            midSpace,
            attrEntries: attrEntries.map(e => e.value),
            multilineIndicator: multilineIndicator ?? "",
            sentencesArray: columns?.value ?? [],
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$tableColumnLine;
//# sourceMappingURL=$tableColumnLine.js.map